import { faGithub } from "@fortawesome/free-brands-svg-icons/faGithub";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons/faEnvelope";
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: "https://github.com/Hyunsoo6257",
    label: "Github",
    icon: faGithub,
  },
  {
    link: "https://www.instagram.com/soo_6257/",
    label: "Instagram",
    icon: faInstagram,
  },
  {
    link: "https://www.linkedin.com/in/hyunsoo-park-ba4b382ba/",
    label: "LinkedIn",
    icon: faLinkedinIn,
  },
  {
    link: "mailto:h28.park@connect.qut.edu.au",
    label: "Email",
    icon: faEnvelope,
  },
];

export default data;
